import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP7PoorRoasOvw202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p7_poor_roas_ovw_202604",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 437,
  clicks: 10,
  adsSpendDollars: 43,
  budgetDollars: 600,
  salesDollars: 0,
  bestEstimateRoas: 0,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.07,
  newCustomersAcquired: 0,
  reorderConversions: 0,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
